import Vue from 'vue';
import Vuex from 'vuex';
import ActionCableVue from 'actioncable-vue';
import Pathify from './pathify';

import media from './modules/media.js';
import medium from './modules/medium.js';
import messages from './modules/messages.js';
import pullQuote from './modules/pull_quote.js';
import squeue from './modules/squeue.js';
import squeues from './modules/squeues.js';
import story from './modules/story.js';
import stories from './modules/stories.js';
import storyMedia from './modules/story_media.js';
import storyPublications from './modules/story_publications.js';
Vue.use(Vuex);

Vue.use(
  ActionCableVue,
  {
    debug: true,
    debugLevel: 'error',
    connectionUrl: '/cable',
    connectImmediately: true,
  }
);

export default new Vuex.Store({
  plugins: [ Pathify.plugin ],
  modules: {
    media,
    medium,
    messages,
    pullQuote,
    squeue,
    squeues,
    story,
    stories,
    storyMedia,
    storyPublications,
  }
});
